import { GenderFieldLexeme } from 'components/page/ProfileCommon/ProfileCommon.types'
import { findLexeme, LexemeItem } from 'functions/findLexeme'
import {
  GQLDatingProfileLexicalOptionType,
  GQLGender,
} from 'generated-graphql/graphql'

/**
 *
 * @param fieldArray
 * @param lexemeArray
 * @param gender
 * Для полей анкеты
 */
export const findLexemeProfileField = (
  fieldArray: string[],
  lexemeArray: GQLDatingProfileLexicalOptionType[],
  gender: GQLGender
): string =>
  fieldArray
    .map((item) => {
      const lexeme = findLexeme(item, lexemeArray as LexemeItem[])
      if (lexeme) {
        return lexeme[GenderFieldLexeme[gender]]
      } else {
        console.warn(`Lexeme not found for "${item}"`)
      }
    })
    .join(', ')
